import {default as axios} from "./axiosConfig";
import config, {axiosConfig} from "../config";


export const smartDriveCheck = async (phone) => {
    const {data} = await axios.post(`${config.API_URL}/mtpl/raxel`, {
        "phone": phone
    }, axiosConfig);

    return data;
}